import { render, staticRenderFns } from "./ArchitectsOrdering.vue?vue&type=template&id=c46d5fea&"
import script from "./ArchitectsOrdering.ts?vue&type=script&lang=ts&"
export * from "./ArchitectsOrdering.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports